<!-- 新版轻骑兵首页 -->
<template>
  <div class="home">
    <!-- Header -->
    <Header @openForm="openForm" :isPageScroll="isPageScroll" :headColor="headColor" :router="'Product'"></Header>
    <!-- banner -->
    <div class="banner-bg">
      <div class="banner-box">
        <div class="banner-con">
          <div class="banner-title">轻骑兵<div style="font-size: 20px;vertical-align: super;line-height: 20px">®</div>零代码开发平台</div>
          <div class="banner-desc">
            人人都是开发者
          </div>
          <div class="banner-btn">
            <div class="banner-btn-appointment" @click="openForm">预约体验</div>
            <div class="banner-btn-expert" @click="openForm">联系行业专家</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底座 -->
    <div class="model-box">
      <div class="model-title">
        <div style="display: inline-flex">
          轻骑兵<div style="font-size: 17px;line-height: normal;">®</div>零代码开发平台
        </div>
      </div>
      <div class="model-desc">更敏捷的企业数字化转型支撑工具</div>
      <div class="model-con two-flex">
        <div class="two-flex-content">
          <img src="../assets/img/zeroCode/two-flex1.png">
          <p>快速上线</p>
          <div class="two-flex-desc">零代码简化了系统开发过程，使用零代码平台搭建应用系统，可以提高5-10倍的效率，缩短上线周期。</div>
        </div>
        <div class="two-flex-content">
          <img src="../assets/img/zeroCode/two-flex2.png">
          <p>更低成本</p>
          <div class="two-flex-desc">无需专业的开发团队，可以省去人工开发的成本，系统上线周期缩短，相关系统实施成本也会大幅下降。</div>
        </div>
        <div class="two-flex-content">
          <img src="../assets/img/zeroCode/two-flex3.png">
          <p>敏捷迭代</p>
          <div class="two-flex-desc">通过零代码平台调整原有业务，几分钟内即可完成系统更新；开展新业务，几个小时就能完成系统搭建，有效提高开发效率。</div>
        </div>
        <div class="two-flex-content">
          <img src="../assets/img/zeroCode/two-flex4.png">
          <p>自主可控</p>
          <div class="two-flex-desc">企业完全掌握应用业务数据， 拥有国家级信息安全和权威认证，保障服务稳定和数据安全，能有效保证业务隐私性。</div>
        </div>
      </div>
      <div class="more-btn" @click="openForm">预约体验</div>
    </div>
    <!-- 现实 -->
    <div class="model-box base-box">
      <div class="model-title">
        <div style="display: inline-flex">
          轻骑兵<div style="font-size: 17px;line-height: normal;">®</div>零代码开发平台 让您的想法更快地变为现实
        </div>
      </div>
      <div class="model-desc">无需编写代码，极速搭建应用程序</div>
      <div class="model-con base-con">
        <img class="model-con-img" src="../assets/img/zeroCode/base-con-img.svg">
      </div>
      <div class="more-btn" @click="openForm" style="position: relative;top: 30px">预约体验</div>
    </div>
    <!-- 新范式 -->
    <div class="model-box new-style">
      <div class="model-title">
        <div style="display: inline-flex">
          轻骑兵<div style="font-size: 17px;line-height: normal;">®</div>零代码开发平台，引领未来应用开发的新范式
        </div>
      </div>
      <div class="model-desc">不只是平台，更是创新的启航点</div>
      <div class="model-con new-style-list">
        <div class="new-style-content">
          <img src="../assets/img/zeroCode/new-style-1.png">
          <div>表单设计器</div>
        </div>
        <div class="new-style-content">
          <img src="../assets/img/zeroCode/new-style-2.png">
          <div>流程设计器</div>
        </div>
        <div class="new-style-content">
          <img src="../assets/img/zeroCode/new-style-3.png">
          <div>数据表格</div>
        </div>
      </div>
      <div class="model-con new-style-list">
        <div class="new-style-content">
          <img src="../assets/img/zeroCode/new-style-4.png">
          <div>数据权限</div>
        </div>
        <div class="new-style-content">
          <img src="../assets/img/zeroCode/new-style-5.png">
          <div>数据工厂</div>
        </div>
        <div class="new-style-content">
          <img src="../assets/img/zeroCode/new-style-6.png">
          <div>API连接</div>
        </div>
      </div>
      <div class="more-btn" @click="openForm" style="position: relative;top: 30px">预约体验</div>
    </div>
    <!-- 主要功能 -->
    <div class="model-box function-box">
      <div class="model-title">主要功能</div>
      <div class="model-con function-con">
        <el-tabs ref="handoffTab" :tab-position="tabPosition" v-model="funActiveName">
          <el-tab-pane name="first">
            <div class="el-tab-paneBox" slot="label" name="first">
              <div class="el-tab-paneBoxIcon1"></div>表单设计器
            </div>
            <div class="fun-tab-con">
              <div class="fun-tab-con-left">
                <div class="fun-tab-conTitle">表单设计器</div>
                <div class="fun-tab-conDesc">通过可视化拖拽+快速配置的方式快速搭建应用系统，一次开发多端适配，支持适配不同分辨率，也支持多段式布局，开发的页面可以实时预览，所见即所得。</div>
                <img src="../assets/img/zeroCode/blue-dian.png">
              </div>
              <div class="fun-tab-conImg fun-tab-conImg1"><img src="../assets/img/zeroCode/tab1.png" style="width: 99%"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="流程设计器" name="second">
            <div class="el-tab-paneBox" slot="label" name="second"><div class="el-tab-paneBoxIcon2"></div>流程设计器</div>
            <div class="fun-tab-con">
              <div class="fun-tab-con-left">
                <div class="fun-tab-conTitle">流程设计器</div>
                <div class="fun-tab-conDesc">提供可视化流程建模能力，支持业务流程快速绘制，提供常用的流程操作，如提交、驳回、加签、撤回等。</div>
                <img src="../assets/img/zeroCode/blue-dian.png">
              </div>
              <div class="fun-tab-conImg fun-tab-conImg2"><img src="../assets/img/zeroCode/tab2.png" style="width: 99%"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="数据表格" name="third">
            <div class="el-tab-paneBox el-tab-paneBoxPad" slot="label" name="third"><div class="el-tab-paneBoxIcon3"></div>数据表格</div>
            <div class="fun-tab-con">
              <div class="fun-tab-con-left">
                <div class="fun-tab-conTitle">数据表格</div>
                <div class="fun-tab-conDesc">支持表单自动生成数据看板，支持用户在运行时自定义显示方案、 查询方案，进行数据导入导出等操作，为企业数据分析提供有效支撑。</div>
                <img src="../assets/img/zeroCode/blue-dian.png">
              </div>
              <div class="fun-tab-conImg fun-tab-conImg3"><img src="../assets/img/zeroCode/tab3.png" style="width: 99%"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="数据权限" name="fourth">
            <div class="el-tab-paneBox el-tab-paneBoxPad" slot="label" name="fourth"><div class="el-tab-paneBoxIcon4"></div>数据权限</div>
            <div class="fun-tab-con">
              <div class="fun-tab-con-left">
                <div class="fun-tab-conTitle">数据权限</div>
                <div class="fun-tab-conDesc">提供开发权限、应用权限、表单权限等多维度多层次的数据权限控制体系。</div>
                <img src="../assets/img/zeroCode/blue-dian.png">
              </div>
              <div class="fun-tab-conImg fun-tab-conImg4"><img src="../assets/img/zeroCode/tab4.png" style="width: 99%"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="仪表板" name="fifth">
            <div class="el-tab-paneBox el-tab-paneBoxPad" slot="label" name="fifth"><div class="el-tab-paneBoxIcon5"></div>数据工厂</div>
            <div class="fun-tab-con">
              <div class="fun-tab-con-left">
                <div class="fun-tab-conTitle">仪表盘</div>
                <div class="fun-tab-conDesc">包含数据流和数据集，数据流支持跨应用、跨表单取数据，支持数据筛选、数据汇总、分组合并、数据联查等功能，数据集支持跨表单取数据。</div>
                <img src="../assets/img/zeroCode/blue-dian.png">
              </div>
              <div class="fun-tab-conImg fun-tab-conImg5"><img src="../assets/img/zeroCode/tab5.png" style="width: 99%"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="API连接" name="sixth">
            <div class="el-tab-paneBox el-tab-paneBoxPad" slot="label" name="sixth"><div class="el-tab-paneBoxIcon6"></div>API连接</div>
            <div class="fun-tab-con">
              <div class="fun-tab-con-left">
                <div class="fun-tab-conTitle">API连接</div>
                <div class="fun-tab-conDesc">支持将已有后端服务(API)通过可视化配置的方式注册到平台上，也可通过图形化编排的方式组合已有API服务开放为新的APl，通过对API的多次组装形成组合应用，实现API的快速复制和创新，以及业务能力和数据的简单、快速、安全开放。</div>
                <img src="../assets/img/zeroCode/blue-dian.png">
              </div>
              <div class="fun-tab-conImg fun-tab-conImg6"><img src="../assets/img/zeroCode/tab6.png" style="width: 99%"></div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="more-btn" @click="openForm">预约体验</div>
      </div>
    </div>
    <!-- 快速构建轻应用 -->
    <div class="model-box value-box">
      <div class="model-title">快速构建轻应用</div>
      <div class="model-con value-con clearfix">
        <ul>
          <li style="margin-right:25px;">
            <div class="value1">
              <p class="value-title">内部系统/小型业务应用</p>
              <p class="value-desc">全员皆可快速搭建内部应用，让专业开发人员专注于核心、复杂业务逻辑的实现，如：日报管理、订餐管理等。</p>
            </div>
          </li>
          <li>
            <div class="value2">
              <p class="value-title">高度灵活、随需求而变的系统</p>
              <p class="value-desc">面对业务需求灵活多变的情况，能够更快地交付，发布即可用，能够快速迭代，如：办公自动化系统等。</p>
            </div>
          </li>
          <li style="margin-right:25px;">
            <div class="value3">
              <p class="value-title">数据填报收集</p>
              <p class="value-desc">对于随机的、业务固化的、繁琐的、不确定的、经常变化的数据填报类的需求，可以快速响应，如：聚餐征集管理等。</p>
            </div>
          </li>
          <li>
            <div class="value4">
              <p class="value-title">对现有业务功能的补充</p>
              <p class="value-desc">以插件的形式集成到现有业务系统中，使其具备零代码开发能力，快速搭建应用，补充现有业务系统的功能不足。</p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 按钮 -->
      <div class="more-btn" @click="openForm">预约体验</div>
    </div>
    <ContactExperts></ContactExperts>
    <!-- footer -->
    <FhBottom/>
    <!-- 右侧联系方式 -->
    <SideBar @openForm="openForm"></SideBar>
    <!-- 表单 -->
    <HussarForm v-show="showForm" @closeForm="closeForm"></HussarForm>
    <!-- 返回顶部 -->
    <img src="../assets/img/homePage/top.png" class="back-top" @click="backTop" v-if="isPageScroll">
  </div>
</template>

<script>
import HussarForm from './include/HussarForm.vue';
import SideBar from './include/SideBar.vue';
import Header from './include/Header.vue';
import ExpendSwiper from './ExpendSwiper.vue';
import CaseSwiper from './CaseSwiper.vue';
import ContactExperts from './include/ContactExperts.vue';

const function21 = require('../assets/img/homePage/function21.gif');
const function22 = require('../assets/img/homePage/function22.gif');

export default {
  name: "ZeroCode",
  data() {
    return {
      tabPosition:'top',
      headColor:"dark",
      isPageScroll: false,
      showForm: false,
      isSubmit: false,
      funActiveName: 'first',
      funcSrc: function21,
      caseBgIndex: 0,
      caseBgList: [
        {
          img: require("../assets/img/homePage/case4-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case5-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case6-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case1-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case2-bg.jpg"),
        },
        {
          img: require("../assets/img/homePage/case3-bg.jpg"),
        },
      ]
    };
  },
  components: {
    ContactExperts,
    Header,
    HussarForm,
    SideBar,
    ExpendSwiper,
    CaseSwiper,
  },
  watch: {
    funActiveName(n) {
      if (n === 'second') {
        this.funcSrc = function21;
        setTimeout(() => {
          this.funcSrc = function22;
        }, 2000);
      }
    }
  },
  methods: {
    // 跳转页面
    jumpTo(page) {
      const self = this;
      self.$router.push({ path: page });
    },
    changeBg(n) {
      const self = this;
      self.caseBgIndex = n;
    },
    openForm() {
      const self = this;
      self.showForm = true;
    },
    closeForm() {
      const self = this;
      self.showForm = false;
    },
    toLink() {
      window.open("http://www.jxdinfo.com");
    },
    // 返回顶部
    backTop() {
      $('html ,body').animate({scrollTop: 0}, 700);
    },
    // 页面滚动
    handleNavScroll() {
      const self = this;
      self.isPageScroll = false;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 80) {
        self.isPageScroll = true;
      }
    },
  },
  mounted() {
    // 视频播放
    var sUserAgent = navigator.userAgent;
    var phoneFlag = sUserAgent.indexOf('Android') > -1 || sUserAgent.indexOf('iPhone') > -1
      || sUserAgent.indexOf('iPad') > -1 || sUserAgent.indexOf('iPod') > -1 || sUserAgent.indexOf('Symbian') > -1;
    if(phoneFlag){
      document.getElementsByTagName('body')[0].classList.add('mobile')
      var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
      document.getElementsByTagName("html")[0].style.fontSize = oWidth/750*100 + "px";
    }
    window.addEventListener('scroll', this.handleNavScroll);
    var ua = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid &&       !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid && !isSymbian;
    var os = {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isPc: isPc
    };
    if (os.isAndroid || os.isPhone) {
      this.$router.replace({ path: '/nocodephone' });
    }
  },
  created() {},
};
</script>

<style scoped>
.home {color: #2E2E2E;}
.home >>> .header-con > div a{height: 100%;display: flex;align-items:center;color: #2e2e2e;}
.home >>> .navigator > div a:hover,.navigator .isActive {color: #186CF5;}
.more-btn {position: relative;left: 50%;transform: translateX(-50%);width: 120px;height: 42px;background: #186CF5;border-radius: 5px;font-size: 16px;text-align: center;color: #FFF;line-height: 42px;cursor: pointer;}
.more-btn:hover {background: rgba(21, 132, 243, 0.9);}
.value-btn {position: relative;left: 50%;transform: translateX(-50%);width: 110px;height: 38px;background: #FFF;border-radius: 5px;font-size: 16px;text-align: center;color: #186CF5;line-height: 38px;cursor: pointer;}
.value-btn:hover {background: rgba(255, 255, 255, 0.9);}

/* banner */
.banner-bg{background: linear-gradient(to right, #D5E2EF 0%, #D5E2EF 50%, #CFE1EF 50%, #CFE1EF 100%);}
.banner-box {width: 100%;height: 630px;background: url('../assets/img/zeroCode/banner-bg.png') no-repeat; background-size: 100% 100%;}
.banner-con {width: 1200px;margin: 0 auto;padding-top: 205px;}
.banner-title {font-size: 50px;font-weight: bold;line-height: 70px;display: flex}
.banner-desc {display: flex;align-items: center;position: relative;height: 40px;font-size: 28px;font-weight: 400;line-height: 40px;}
.banner-desc img {margin-left: 6px;z-index: 2;width: 45px}
.banner-desc img:hover {transform: scale(1.2);}
.banner-btn {position: relative;margin-top: 54px;cursor: pointer;}
.banner-btn-appointment {display: inline-block;width: 158px;height: 54px;background: linear-gradient(90deg, #018DFF 0%, #1A74F1 100%);border-radius: 5px;color: #FFF;font-size: 18px;text-align: center;line-height: 54px;}
.banner-btn-appointment:hover {background: linear-gradient(90deg, #186CF5 0%, #095EE9 100%);}
.banner-btn-expert {display: inline-block;width: 158px;height: 54px;margin-left: 13px;border: 1px solid #1D79FB;border-radius: 5px;line-height: 54px;color: #1D79FB;font-size: 18px;text-align: center;}
.banner-btn-expert:hover {background: rgba(29, 121, 251, 0.1);}

/*更敏捷*/
.two-flex{display: flex;}
.two-flex .two-flex-content{padding:0px 20px;margin:60px 5px;width: 305px;height: 384px;background: linear-gradient( 44deg, #FFFFFF 0%, #F5F9FF 100%);border-radius: 2px 2px 2px 2px;border: 1px solid #EBF3FF; }
.two-flex .two-flex-content:hover{border: 1px solid #3581F3;}
.two-flex-content p{text-align: center;font-size: 20px;line-height: 31px;font-weight: bold;position: relative;top:-40px;}
.two-flex-content .two-flex-desc{font-size: 14px;color: #2e2e2e;line-height: 31px;position: relative;top:-30px;text-align: justify}
.two-flex-content img{height: 234px;margin: auto;position: relative;top:-15px;}

/*现实*/
.base-box{background: linear-gradient(to bottom, #EFF4FF,#FCFDFF)}
.model-box {position: relative;width: 100%;padding: 80px 0 100px 0;}
.model-con {width: 1200px;margin: 0 auto;position: relative;}
.model-con-img {width: 1116px;height: 658px;margin: 50px auto}
.model-title {font-size: 34px;font-weight: bold;text-align: center;line-height: 52px;}
.model-desc {font-size: 22px;text-align: center;line-height: 60px;height: 43px;}

/*新范式*/
.new-style{background: url("../assets/img/zeroCode/new-style-bg.png") no-repeat;background-size: 100% 100%;color: #fff}
.new-style .model-desc{margin-bottom: 40px}
.new-style-list{display: flex}
.new-style-content{display: flex;width: 300px;height: 110px;border-radius: 5px;box-shadow: 0px 0px 10px 1px rgba(0,28,94,0.18);background: #fff;opacity: 0.9;margin:30px 50px;color: #2e2e2e;padding: 0px 40px 0px 20px}
.new-style-content > div{font-size: 21px;font-weight: bold;margin: auto}

/* 主要功能 */
.function-box {height: 918px;background: #F6F9FE;}
.function-con {height: 653px;padding-top: 12px;}
.fun-tab-con {width: 1200px;height: 609px;border-radius: 4px 4px 4px 4px;opacity: 1;padding-top: 20px;display: flex}
.function-con >>> .el-tabs__content {height: calc(100% - 126px);}
.function-con >>> .el-tabs__header {margin-bottom: 68px;margin-right: unset!important;}
.function-con >>> .el-tabs__nav-wrap::after {display: none;}
.function-con >>> .el-tabs__active-bar {display: none;}
.function-con >>> .el-tabs__nav {width: 100%;text-align: center;}
.function-con >>> .el-tabs__item {width: 175px;height: 58px;padding: 0;margin: 38px 30px 0 0;line-height: 58px;text-align: center;font-size: 20px;color: #333;background: #F6F9FE;border-radius: 2px;}
.el-tab-paneBox {display: flex;align-items: center;justify-content: center;height: 100%;width: 100%;position: relative;}
.el-tab-paneBoxPad {padding-right: 20px;}
.el-tab-paneBoxIcon1 {width: 40px;height: 40px;background: url("../assets/img/zeroCode/main-white-001.png") no-repeat;background-size: 100% 100%;margin-right: 5px}
.el-tab-paneBoxIcon2 {width: 40px;height: 40px;background: url("../assets/img/zeroCode/main-white-002.png") no-repeat;background-size: 100% 100%;margin-right: 5px}
.el-tab-paneBoxIcon3 {width: 40px;height: 40px;background: url("../assets/img/zeroCode/main-white-003.png") no-repeat;background-size: 100% 100%;margin-right: 5px}
.el-tab-paneBoxIcon4 {width: 40px;height: 40px;background: url("../assets/img/zeroCode/main-white-004.png") no-repeat;background-size: 100% 100%;margin-right: 5px}
.el-tab-paneBoxIcon5 {width: 40px;height: 40px;background: url("../assets/img/zeroCode/main-white-005.png") no-repeat;background-size: 100% 100%;margin-right: 5px}
.el-tab-paneBoxIcon6 {width: 40px;height: 40px;background: url("../assets/img/zeroCode/main-white-006.png") no-repeat;background-size: 100% 100%;margin-right: 5px}
.function-con >>> #tab-0 {margin-top: 0;}
.function-con >>> #tab-first {margin-top: 0;}
.function-con >>> .el-tabs__item.is-active {color: #FFF;background: url("../assets/img/zeroCode/buttion-bg.png") no-repeat;background-size: 100% 100%;}
.function-con >>> .is-active .el-tab-paneBoxIcon1 {width: 40px;height: 40px;background: url("../assets/img/zeroCode/main-blue-001.png") no-repeat;background-size: 100% 100%;margin-right: 5px}
.function-con >>> .is-active .el-tab-paneBoxIcon2 {width: 40px;height: 40px;background: url("../assets/img/zeroCode/main-blue-002.png") no-repeat;background-size: 100% 100%;margin-right: 5px}
.function-con >>> .is-active .el-tab-paneBoxIcon3 {width: 40px;height: 40px;background: url("../assets/img/zeroCode/main-blue-003.png") no-repeat;background-size: 100% 100%;margin-right: 5px}
.function-con >>> .is-active .el-tab-paneBoxIcon4 {width: 40px;height: 40px;background: url("../assets/img/zeroCode/main-blue-004.png") no-repeat;background-size: 100% 100%;margin-right: 5px}
.function-con >>> .is-active .el-tab-paneBoxIcon5 {width: 40px;height: 40px;background: url("../assets/img/zeroCode/main-blue-005.png") no-repeat;background-size: 100% 100%;margin-right: 5px}
.function-con >>> .is-active .el-tab-paneBoxIcon6 {width: 40px;height: 40px;background: url("../assets/img/zeroCode/main-blue-006.png") no-repeat;background-size: 100% 100%;margin-right: 5px}
.function-con >>> .fun-tab-con-left {width: 370px;}
.function-con >>> .fun-tab-con-left img{position: relative;top: -192px}
.function-con >>> .fun-tab-conTitle {width: 200px;height: 80px;font-size: 24px;color: #333333;font-weight: bold}
.function-con >>> .fun-tab-conDesc {width: 300px;height: 200px;font-size: 14px;color: #2e2e2e;line-height: 31px;text-align: justify;padding-left: 20px}
.function-con >>> .fun-tab-conImg {width: 875px;height: 522px;margin: 15px;}
.fun-tab-conImg img{box-shadow: 0px 0px 10px 1px rgba(10,63,190,0.17);}
.fun-tab-conImg video{width: 100%;box-shadow: 0px 0px 10px 1px rgba(10,63,190,0.17);}
.home .el-tabs--left .el-tabs__header.is-left {margin-right: 0;}
.tab-left {width: 366px;float: left;position: relative;padding-right: 44px;}
.left-title {margin: 12px 0 58px;font-size: 28px;font-weight: bold;color: #333;line-height: 40px;}
.tab-left ul {font-size: 14px;line-height: 31px;}
.tab-left ul li span {display: block;float: left;width: calc(100% - 24px);}
.tab-left ul li span.fun-li-circle {display: block;width: 14px;height: 14px;margin-right: 10px;position: relative;top: 9px;background: linear-gradient(180deg, #2377FF 0%, #BDD6FF 100%);border-radius: 50%;}
.tab-right {width: calc(100% - 366px);float: left;text-align: center;}
.tab-right img.boxshadow {box-shadow: 0 3px 10px 1px rgba(0, 0, 0, .16);}
.function-box .more-btn {position: relative;left: 50px;top:-250px;}

/* 快速构建轻应用 */
.value-box {height: 772px;}
.value-con {padding-top: 60px;padding-bottom:35px;font-size: 16px;color: #2E2E2E;line-height: 31px;}
.value-con ul li {width: 586px;height: 192px;float: left;margin-bottom: 25px;border-radius: 5px;background:#F7FAFD;color: #2e2e2e;padding: 30px 20px 5px 30px}
.value-con ul li div{float: left;height: 100%;}
.value-con ul li div:nth-child(2){width: 84%;background: #2D6EEB;border-radius: 5px;padding: 20px 5px 10px 20px}
.value-con ul li:nth-child(3n) {margin-right: 0;}
.value-con ul li p.value-title {font-size: 20px;font-weight: bold;margin-bottom: 10px}
.value-con ul li p.value-desc {font-size: 16px;}
.value-box .value1{background: url("../assets/img/zeroCode/value-box-white1.png") no-repeat;background-position: right bottom;}
.value-box .value2{background: url("../assets/img/zeroCode/value-box-white2.png") no-repeat;background-position: right bottom;}
.value-box .value3{background: url("../assets/img/zeroCode/value-box-white3.png") no-repeat;background-position: right bottom;}
.value-box .value4{background: url("../assets/img/zeroCode/value-box-white4.png") no-repeat;background-position: right bottom;}
.value-con ul li:hover{background: #115CE0;color: #fff}
.value-box .value1:hover{background: url("../assets/img/zeroCode/value-box-blue1.png") no-repeat;background-position: right bottom;}
.value-box .value2:hover{background: url("../assets/img/zeroCode/value-box-blue2.png") no-repeat;background-position: right bottom;}
.value-box .value3:hover{background: url("../assets/img/zeroCode/value-box-blue3.png") no-repeat;background-position: right bottom;}
.value-box .value4:hover{background: url("../assets/img/zeroCode/value-box-blue4.png") no-repeat;background-position: right bottom;}

/* 案例 */
.case-box {height: 800px;transition: background 1s ease;background-repeat: no-repeat !important; background-size: cover !important;}
.case-box .model-title, .case-box .model-desc {color: #FFF;}
.case-con {display: flex;margin-top: 54px;margin-bottom: 40px;}
.case-industry {background: url('../assets/img/homePage/case-industry-bg.png');width: 275px;height: 428px;padding: 16px 39px 0 32px;color: #FFF;}
.case-industry-title {font-size: 20px;font-weight: bold;line-height: 52px;border-bottom: 1px solid #FFF;}
.case-industry ul li {float: left;margin-top: 32px;width: 64px;margin-right: 56px;font-size: 16px;}
.case-industry ul li:nth-child(2n) {margin-right: 0;}
.case-more-btn {background: linear-gradient(90deg, #1A74F1 0%, #018DFF  100%);position: relative;left: 50%;transform: translateX(-50%);width: 105px;height: 44px;border-radius: 5px;font-size: 14px;text-align: center;color: #FFF;line-height: 44px;cursor: pointer;}
.case-more-btn img {margin-left: 3px;transition: all .3s ease;}
.case-more-btn:hover img {transform: translateX(8px);}

/* 返回顶部 */
.back-top {position: fixed;top: calc(40% + 250px);right: 5px;cursor: pointer;}
/*取消页面光标*/
.model-box div,img{caret-color: transparent;}
</style>



// WEBPACK FOOTER //
// src/components/ZeroCode.vue